var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import { Auth, Layout, Dependencies } from "~/core/decorator";
import { SystemLogService } from "~/services/management-service/system-log.service";
import { PageService } from "~/utils/page.service";
import DataForm from "~/components/common/data-form.vue";
var SystemLog = /** @class */ (function (_super) {
    __extends(SystemLog, _super);
    function SystemLog() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.systemLogModel = {
            userRealName: "",
            operatorTime: []
        };
        _this.systemLogDataSet = [];
        return _this;
    }
    SystemLog.prototype.refreshData = function () {
        var _this = this;
        this.systemLogService
            .getAllSystemLogs(this.systemLogModel, this.pageService)
            .subscribe(function (data) {
            _this.systemLogDataSet = data;
        });
    };
    SystemLog.prototype.mounted = function () {
        this.refreshData();
    };
    __decorate([
        Dependencies(SystemLogService)
    ], SystemLog.prototype, "systemLogService", void 0);
    __decorate([
        Dependencies(PageService)
    ], SystemLog.prototype, "pageService", void 0);
    SystemLog = __decorate([
        Auth(15),
        Layout("workspace"),
        Component({
            components: {
                DataForm: DataForm
            }
        })
    ], SystemLog);
    return SystemLog;
}(Vue));
export default SystemLog;
